"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAlphaNumeric = exports.formatIdentityValue = void 0;
var account_api_1 = require("@newfront-insurance/account-api");
var obfuscation_1 = require("./obfuscation");
var UNFORMATTER_REGEXP = new RegExp("[^a-zA-Z0-9".concat(obfuscation_1.OBFUSCATION_CHAR, "]"), 'ig');
var formatters = (_a = {},
    _a[account_api_1.IdentityType.BUSINESS_IDENTIFIER] = {
        US: function (value) { return "".concat(value.slice(0, 2), "-").concat(value.slice(2)); },
    },
    _a);
function formatIdentityValue(identity) {
    var _a;
    if (!identity || !identity.value) {
        return '';
    }
    var type = identity.type, countryCode = identity.countryCode, value = identity.value;
    var unformatted = String(value).replace(UNFORMATTER_REGEXP, '');
    var formatter = (_a = formatters[type]) === null || _a === void 0 ? void 0 : _a[countryCode];
    return formatter ? formatter(unformatted) : unformatted;
}
exports.formatIdentityValue = formatIdentityValue;
function toAlphaNumeric(value) {
    if (!value) {
        return '';
    }
    return String(value).replace(/[^a-zA-Z0-9]+/g, '');
}
exports.toAlphaNumeric = toAlphaNumeric;
//# sourceMappingURL=index.js.map